export const APP_NAME = "Codepresso";
export const API_BASE_URL = process.env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = "/app";
